var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"has-text-weight-normal"},[_vm._v(_vm._s(_vm.reviewText)+" "),_c('a',{attrs:{"href":_vm.reviewLink,"target":"_blank"}},[_vm._v(_vm._s(_vm.linkText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }